<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="inconsistências"
    >
        <rkm-table
            :fields="fields"
            :items="items"
        />

        <template v-slot:footer="{cancel}">
            <rkm-button
                @click="cancel"
                color="secondary"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    data: () => ({
        fields: [
            {key: 'diagnostics', label: 'Diagnostics', sortable: true},
        ],
        items: [],
    }),
    methods: {
        open(items) {
            this.items = items
            this.$refs.RkmModal.show()
        },
    },
}
</script>